export default "__VITE_ASSET__BSsGIufd__"